import { render, staticRenderFns } from "./maintenanceItem.vue?vue&type=template&id=2ff56bb5&scoped=true&"
import script from "./maintenanceItem.vue?vue&type=script&lang=js&"
export * from "./maintenanceItem.vue?vue&type=script&lang=js&"
import style0 from "./maintenanceItem.vue?vue&type=style&index=0&id=2ff56bb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff56bb5",
  null
  
)

component.options.__file = "maintenanceItem.vue"
export default component.exports